// import React, { useEffect, useRef, useState } from 'react'
// import QBuilderEditWrapper from './widgets/QBuilderEditWrapper'
// import QBuilderSideMenuContainer from './widgets/QBuilderSideMenuContainer'
// import QBuilderGeneralQuestionInfo from './QBuilderGeneralQuestionInfo'
// import QBuilderGenerics from '../QBuilderGenerics'
// import QBuilderValidationWrapper from './Generic/QBuilderValidationWrapper'
// import QBuilderComponentDynamicComponentTableLayout from './widgets/DynamicComponentTable/QBuilderComponentDynamicComponentTableLayout'
// import QBuilderComponentDynamicComponentTableComponent from './widgets/DynamicComponentTable/QBuilderComponentDynamicComponentTableComponent'
// import Questionnaire from '../../../../../libs/api/services/Questionnaire'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useContext, useState } from "react"
import { PlusCircleDotted } from "react-bootstrap-icons"
import QuestionnaireBuilderContext from "../QuestionnaireBuilderProvider"
import QBuilderComponent from "./QBuilderComponent"
import { AdminEditText, AdminLayoutWrapper, CommonLayoutWrapper } from "./QBuilderComponentMultiSelect"
import QBuilderComponentDynamicComponentTableLayout from './widgets/DynamicComponentTable/QBuilderComponentDynamicComponentTableLayout'

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
export default function QBuilderComponentDynamicComponentTable({
    Component,
    activeQuestionnaireAssignment,
    accessTypes,
    onAction,
    idx,
    edit,
    view,
    defaultMode,
    SectionComponents,
    values, }) {
    const { SetComponentValue, GetComponentValues, SetResponse, ComponentAnswers } = useContext(QuestionnaireBuilderContext)
    const [mode, setMode] = useState(edit ? '' : '')

    // if (!accessTypes) return <></>
    return <CommonLayoutWrapper
        OnEdit={() => setMode('Edit Text')}
        edit={edit}
        mode={mode}
        accessTypes={accessTypes}
        AdminMode={<AdminLayoutWrapper
            Component={Component}
            mode={mode}
            setMode={setMode}
            Tabs={{
                "Details": {
                    mode: "Set Text",
                    component: <AdminEditText Component={Component} />
                },
                "Layout": {
                    mode: "Layout",
                    component: <QBuilderComponentDynamicComponentTableLayout
                        onSetData={() => { }}
                        edit={true}
                        Component={Component}
                    // properties={properties}
                    // onChanged={(k, v) => _handleSetProperty(k, v)}
                    />
                },
            }}
        />}
        NormalMode={
            <>
                {GetComponentValues(Component.id)["Question"]}
                {GetComponentValues(Component.id)["Items"] &&
                    <>
                        <table
                            key={'qbc' + generateUUID}
                            className='rounded table-transparent-bg'>
                            <tr>
                                {JSON.parse(GetComponentValues(Component.id)["Items"]).map(component =>
                                    <th>{component.name && component.name}</th>
                                )}
                            </tr>
                            {/* {_generateHeading(items)} */}
                            <tbody>
                                {/* {_table ? _table : <></>} */}
                                <tr>
                                    {JSON.parse(GetComponentValues(Component.id)["Items"]).map(component =>

                                        <td>
                                            <QBuilderComponent
                                                Component={component.component}
                                                accessTypes={accessTypes}
                                                edit={false}
                                                defaultMode={defaultMode}
                                                SectionComponents={SectionComponents}
                                                values={values}
                                                type={component.type.type}
                                            />
                                        </td>

                                    )}
                                </tr>
                                <tr

                                    // onClick={() => _handleAddLineItem()} 

                                    style={{ cursor: 'pointer' }}>
                                    {mode !== 'Discover' ? <td className='text-center'
                                        colSpan={JSON.parse(GetComponentValues(Component.id)["Items"]).length + 1}
                                    >
                                        <PlusCircleDotted /> Add</td> : <></>}
                                </tr>
                            </tbody>
                        </table>


                        {/* <QBuilderComponent
                            Component={component.component}
                            accessTypes={accessTypes}
                            edit={edit}
                            defaultMode={defaultMode}
                            SectionComponents={SectionComponents}
                            values={values}
                            type={component.type.type}
                        /> */}
                        {/* <div>{JSON.stringify(component.type.type)}</div> */}
                    </>
                }
            </>
        }
    />
}
